var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgShopper = function SvgShopper(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 80,
    viewBox: "0 0 95 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B9785F",
    d: "M91.124 78.24H3.254V1.76c0-.898.729-1.627 1.628-1.627h84.614c.899 0 1.628.73 1.628 1.628v76.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA6455",
    d: "M91.124 26.029c-.334.083-.677.14-1.036.14-2.37 0-4.29-1.921-4.29-4.29 0 2.369-1.92 4.29-4.29 4.29s-4.29-1.921-4.29-4.29c0 2.369-1.92 4.29-4.29 4.29s-4.29-1.921-4.29-4.29c0 2.369-1.92 4.29-4.29 4.29-2.369 0-4.29-1.921-4.29-4.29 0 2.369-1.92 4.29-4.29 4.29-2.369 0-4.29-1.921-4.29-4.29 0 2.369-1.92 4.29-4.29 4.29-2.369 0-4.29-1.921-4.29-4.29 0 2.369-1.92 4.29-4.29 4.29-2.369 0-4.29-1.921-4.29-4.29 0 2.369-1.92 4.29-4.29 4.29-2.369 0-4.29-1.921-4.29-4.29 0 2.369-1.92 4.29-4.29 4.29-2.369 0-4.29-1.921-4.29-4.29 0 2.369-1.92 4.29-4.29 4.29-2.368 0-4.29-1.921-4.29-4.29 0 2.369-1.92 4.29-4.29 4.29-.358 0-.701-.057-1.035-.14v3.29c.342.047.681.104 1.036.104 1.592 0 3.071-.496 4.29-1.341 1.219.845 2.697 1.341 4.29 1.341s3.071-.496 4.29-1.341c1.219.845 2.698 1.341 4.29 1.341s3.071-.496 4.29-1.341c1.219.845 2.697 1.341 4.29 1.341 1.592 0 3.071-.496 4.29-1.341 1.219.845 2.697 1.341 4.29 1.341 1.592 0 3.071-.496 4.29-1.341 1.218.845 2.697 1.341 4.29 1.341 1.592 0 3.07-.496 4.29-1.341 1.218.845 2.697 1.341 4.29 1.341 1.592 0 3.07-.496 4.29-1.341 1.218.845 2.697 1.341 4.29 1.341 1.592 0 3.07-.496 4.29-1.341 1.218.845 2.697 1.341 4.29 1.341 1.592 0 3.07-.496 4.29-1.341 1.218.845 2.697 1.341 4.29 1.341 1.592 0 3.07-.496 4.29-1.341 1.218.845 2.697 1.341 4.29 1.341.354 0 .693-.057 1.035-.105v-3.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4E1FA",
    d: "M11.39 32.678H56.952V61.967999999999996H11.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAF0FD",
    d: "M48.816 60.34L45.562 60.34 26.035 34.305 29.29 34.305z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D2555A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.609 8.289c-2.37 0-4.29-1.921-4.29-4.29V.153h8.58v3.846c0 2.369-1.92 4.29-4.29 4.29zM55.769 8.289c-2.37 0-4.29-1.921-4.29-4.29V.153h8.58v3.846c0 2.369-1.92 4.29-4.29 4.29zM21.45 8.289c-2.37 0-4.29-1.921-4.29-4.29V.153h8.58v3.846c0 2.369-1.921 4.29-4.29 4.29zM4.29 8.289C1.92 8.289 0 6.368 0 3.999V.153h8.58v3.846c0 2.369-1.92 4.29-4.29 4.29zM72.928 8.289c-2.369 0-4.29-1.921-4.29-4.29V.153h8.58v3.846c0 2.369-1.92 4.29-4.29 4.29z",
    transform: "translate(0 17.88)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#C7CFE2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.407 8.289c-2.369 0-4.29-1.921-4.29-4.29V.153h8.58v3.846c0 2.369-1.92 4.29-4.29 4.29zM38.726 8.289c-2.369 0-4.29-1.921-4.29-4.29V.153h8.58v3.846c0 2.369-1.92 4.29-4.29 4.29z",
    transform: "translate(25.622 17.88)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D2555A",
    d: "M90.088 26.169c-2.37 0-4.29-1.92-4.29-4.29v-3.846h8.58v3.846c0 2.37-1.92 4.29-4.29 4.29z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#C7CFE2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.029 8.289c-2.37 0-4.29-1.921-4.29-4.29V.153h8.58v3.846c0 2.369-1.921 4.29-4.29 4.29zM4.39 8.289C2.021 8.289.1 6.368.1 3.999V.153h8.58v3.846c0 2.369-1.92 4.29-4.29 4.29zM38.71 8.289c-2.37 0-4.29-1.921-4.29-4.29V.153H43v3.846c0 2.369-1.921 4.29-4.29 4.29z",
    transform: "translate(8.48 17.88)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FF6464"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.899 13.056L34.319 13.056 35.207.038 43.195.038zM60.059 13.056L51.479 13.056 51.183.038 59.171.038zM25.739 13.056L17.16 13.056 19.231.038 27.219.038zM8.58 13.056L0 13.056 3.254.038 11.243.038zM77.218 13.056L68.638 13.056 67.159.038 75.147.038z",
    transform: "translate(0 4.977)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#EFF2FA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.697 13.056L.117 13.056 1.596.038 9.585.038zM43.016 13.056L34.436 13.056 33.549.038 41.537.038z",
    transform: "translate(25.622 4.977)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6464",
    d: "M94.378 18.033L85.798 18.033 83.135 5.015 91.124 5.015z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#EFF2FA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.319 13.056L68.739 13.056 66.668.038 74.656.038zM8.68 13.056L.101 13.056 2.763.038 10.751.038zM43 13.056L34.42 13.056 34.716.038 42.704.038z",
    transform: "translate(8.48 4.977)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C7CFE2",
    d: "M92.75 79.867H1.628C.73 79.867 0 79.137 0 78.239c0-.898.729-1.627 1.627-1.627h91.124c.898 0 1.627.729 1.627 1.627 0 .899-.729 1.628-1.627 1.628z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFB9D2",
    d: "M0.121 0.178H87.99V3.432H0.121z",
    opacity: 0.97,
    transform: "translate(3.134 73.18)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AA6455",
    d: "M3.254 66.849H91.123V73.358H3.254z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5B5D6E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.74 3.337v26.035H3.432V3.337H45.74M47.367.083H1.805C.907.083.178.81.178 1.71V31c0 .898.729 1.627 1.627 1.627h45.562c.898 0 1.627-.729 1.627-1.627V1.71c0-.899-.728-1.627-1.627-1.627zM73.402.083H57.13c-.898 0-1.627.728-1.627 1.627v40.68h19.526V1.71c0-.899-.728-1.627-1.627-1.627z",
    transform: "translate(9.585 30.968)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B4E1FA",
    d: "M68.343 34.305H81.361V60.34H68.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2F0",
    d: "M13.018 34.305H55.325V37.559H13.018zM68.343 34.305H81.361V37.559H68.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2F0",
    d: "M42.307 60.34L35.799 60.34 16.272 34.305 22.781 34.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4E1FA",
    d: "M31.731 37.559L29.29 34.305 26.035 34.305 28.476 37.559z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAF0FD",
    d: "M81.36 47.322L71.597 34.305 68.343 34.305 81.36 51.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4E1FA",
    d: "M74.038 37.559L71.597 34.305 68.343 34.305 70.783 37.559z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2F0",
    d: "M68.343 34.305H81.361V37.559H68.343z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAF0FD",
    d: "M81.36 47.322L71.597 34.305 68.343 34.305 81.36 51.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A0D2F0",
    d: "M68.343 38.644L68.343 47.322 78.106 60.34 81.36 60.34 81.36 56.001z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShopper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopper.5ad321d0.svg";
export { ForwardRef as ReactComponent };